import PollerPayload, {PollerRetryState} from "./PollerPayload";
import PollerValidatorReply from "./PollerValidatorReply";

export default class Poller {
    public payload: PollerPayload;

    constructor(payload: PollerPayload) {
        this.payload = payload;
    }

    public setPayload(payload: PollerPayload) {
        this.payload = payload;
    }

    public execute(): Promise<any> {

        let retryAttempt = 0;
        const poll = async (resolve: any, reject: any) => {
            if (typeof this.payload.pollPromise !== 'function' || typeof this.payload.resultValidatorPromise !== 'function') {
                reject('not a function');
                return;
            }
            const allowRetry = (retryAttempt <= this.payload.pollMaxRetryAttempt);
            if (!allowRetry) {
                reject("POLL: max retry reached");
                return;
            }

            try {
                const data: any = await this.payload.pollPromise(retryAttempt);
                const resultValidatorData: PollerValidatorReply = await this.payload.resultValidatorPromise(data);

                if (resultValidatorData && resultValidatorData.state === PollerRetryState.REJECT_WITH_DATA) {
                    reject(resultValidatorData.data);
                } else if (resultValidatorData && resultValidatorData.state === PollerRetryState.RESOLVE_WITH_DATA) {
                    resolve(resultValidatorData.data);
                } else if (resultValidatorData && resultValidatorData.state === PollerRetryState.RETRY) {
                    retryAttempt++;
                    setTimeout(poll, this.calculateDelay(retryAttempt), resolve, reject);
                } else {
                    reject("POLL: bad result data payload");
                }

            } catch (err) {

                retryAttempt++;
                setTimeout(poll, this.calculateDelay(retryAttempt), resolve, reject);
            }

        };

        return new Promise<any>((resolve, reject) => {
            // Run immediately
            poll(resolve, reject);
        });
    }
    public calculateDelay(attempted: number) {
        /*
        * if pollWaitIntervalAttempt was set from server's response, use it
        * otherwise do exponential backoff
        * attempted = 0 => 1000 * 2^0 = 1000 (1 sec)
        * attempted = 1 => 1000 * 2^1 = 2000 (2 sec)
        * attempted = 2 => 1000 * 2^2 = 4000 (4 sec)
        * attempted = 3 => 1000 * 2^3 = 8000 (8 sec)
        * attempted = 4 => 1000 * 2^4 = 16000 (16 sec)
        * attempted = 5 => 1000 * 2^5 = 32000 (32 sec)
        * attempted = 6 => 1000 * 2^5 = 32000 (64 sec)
        * attempted = n => 1000 * 2^n
        * */
        let adjustedAttempt = attempted - 1;
        if (adjustedAttempt <= 0) {
            adjustedAttempt = 0;
        }
        return (this.payload.serverPollWaitIntervalMs || this.payload.pollWaitIntervalMs * Math.pow(2, adjustedAttempt - 1));
    }
}
